import React from "react";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";
import style from "./anatomyEdit.module.scss";

export const AnatomyZoom = ({ viewer, svgContent }) => {
  return (
    <TransformWrapper ref={viewer} initialScale={1} minScale={1} maxScale={4} centerOnInit={true} limitToBounds={true}>
      {({ zoomIn, zoomOut, resetTransform }) => (
        <div className="position-relative w-100 mx-4 mt-4 mb-2">
          <TransformComponent
            wrapperClass={`d-flex justify-content-center align-items-center ${style.wrapperClass}`}
            contentClass="d-flex justify-content-center align-items-center w-100 h-100"
          >
            {svgContent}
          </TransformComponent>
          <div className={`${style.zoomIcon}`}>
            <i
              className={`${style.iconHover} fa fa-search-plus`}
              style={{ color: "#808080" }}
              onClick={() => zoomIn(0.2)}
              aria-hidden="true"
              data-testid="zoomInAction"
            ></i>
            <i
              className={`${style.iconHover} fa fa-search-minus`}
              style={{ color: "#808080" }}
              onClick={() => zoomOut(0.2)}
              aria-hidden="true"
              data-testid="zoomOutAction"
            ></i>
            <i
              className={`${style.iconHover} fa fa-arrows-alt`}
              style={{ transform: `rotate(45deg) scale(1.1)`, color: "#808080" }}
              onClick={() => resetTransform()}
              aria-hidden="true"
              data-testid="reSizeAction"
            ></i>
          </div>
        </div>
      )}
    </TransformWrapper>
  );
};
